@if (viewModel$ | async; as viewModel) {
  <div class="my-3 fx-column">
    <lc-property-photo-upload [marketingOrderId]="viewModel.photoOrder.marketingOrderId" (uploadResult)="uploadResult(viewModel.photoOrder, $event)" />
    <!-- Working Photos Section -->
    @if (viewModel.workingPhotos; as workingPhotos) {
      <div id="unsubmitted-photos-section">
        <div class="mt-5">
          <h4>{{workingPhotos.length}} Unsubmitted</h4>
        </div>
        <button id="submit-photos" mat-raised-button type="submit" [disabled]="!isSubmitEnabled" (lcDebounceClick)="submitPhotos(viewModel.photoOrder, workingPhotos)" >Submit Selected</button>
        @if (!workingPhotos.length) {
          <div class="text-center"><h5 class="text-faded font-weight-bold py-3 my-4">No photos uploaded yet</h5></div>
        }
        @if (workingPhotos.length) {
          <lc-photo-list
            [favoritesEnabled]="false"
            [marketingOrder]="null"
            [viewModels]="workingPhotos"
            (selected)="onUpdateSelectedPhotos($event)"
            (updatePhotos)="updateWorkingPhotos(viewModel.photoOrder, $event)"
            />
        }
      </div>
    }
    <!-- Submitted Photos Section -->
    @if (viewModel.submittedPhotos) {
      <div id="submitted-photos-section">
        <div class="mt-5">
          <h4>{{viewModel.submittedPhotos?.length}} Submitted</h4>
        </div>
        @if (!viewModel.submittedPhotos.length) {
          <div class="text-center"><h5 class="text-faded font-weight-bold py-3 my-4">No photos submitted yet</h5></div>
        }
        @if (viewModel.submittedPhotos?.length) {
          <lc-photo-list [deleteEnabled]="false" [downloadEnabled]="false"
            [dragDropEnabled]="false"
            [favoritesEnabled]="false"
            [marketingOrder]="null"
            [numberOrderingEnabled]="false"
            [selectEnabled]="false"
            [showMenu]="false"
            [viewModels]="viewModel.submittedPhotos" />
        }
      </div>
    }
    @if (viewModel.canComplete) {
      <div class="d-flex justify-content-end">
        <button id="complete-order" mat-raised-button type="submit" (click)="onComplete(viewModel.photoOrder)">Complete Order</button>
      </div>
    }
  </div>
}
